import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

import axios from "axios";

class AssignTripStore {
  assignTrip = [];
  vehicles = [];
  geoDataArray = [];
  tripDataArray = [];
  total = 0;
  loading = false;
  rootStore;
  idlePoints = [];
  addr = "";

  constructor(rootStore) {
    makeObservable(this, {
      idlePoints: observable,
      assignTrip: observable,
      geoDataArray: observable,
      vehicles: observable,
      tripDataArray: observable,
      total: observable,
      loading: observable,
      addr: observable,

      loadData: action,
      getAddressUsingLatLng: action,

      getVehicles: action,
      getGeoData: action,
      getStopeIdle: action,
      deleteTrip: action,
    });
    this.rootStore = rootStore;
  }

  // async loadData({ companyId }) {
  //   var postData = { companyId: companyId };
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=trip&a=getTripdata", "postData=" + base64Input);
  //   console.log(response);
  //   this.tripDataArray = response.data.data;
  // }

  async loadData({ offset, limit, companyId }) {
    this.loading = true;

    const params = { companyId: companyId };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("TripDetails/getTripData", { params: params });

    this.tripDataArray = response.data.data;

    this.loading = false;
  }

  // async createTrip({ obj, routePoints }) {
  //   var postData = { tokenId: "", AddRoute: obj, routePoints: routePoints };
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=trip&a=create", "postData=" + base64Input);
  //   console.log(response);
  //   return response;
  // }

  async createTrip({ obj, routePoints }) {
    var postData = { tokenId: "", AddRoute: obj, routePoints: routePoints };
    var tripData = { postData };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("TripDetails/createOrUpdateTrip", tripData);
    return response;
  }

  async getVehicles(companyId) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/getVehicles", { params: postData });
    this.vehicles = response?.data?.vehicleData;
  }
  async getGeoData(companyId, geoZoneId, vehicleId) {
    var postData = {
      companyId: companyId,
      geoZoneId: geoZoneId,
      vehicleId: vehicleId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=geofence&a=geoData", "postData=" + base64Input);
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("taxi/geoData", {
        params: postData,
      });

    this.geoDataArray = response.data.geofence;
  }

  async getStopeIdle(object) {
    var postData = object;
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=trip&a=getstopidle", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("TripDetails/getStopIdleData", { params: postData });
    this.idlePoints = response?.data?.data;

    return response;
  }

  async deleteTrip({ stId }) {
    // var postData = { stId: stId };
    // console.log(postData);
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=trip&a=delete", "postData=" + base64Input);

    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("TripDetails/deleteTrip", {
        params: {
          stId: stId,
        },
      });

    return response;
  }

  async getAssignTripRecord(stId) {
    const params = { stId, limit: 1, offset: 0 };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("TripDetails/getTripData", {
        params: params,
      });
    return response.data.data[0];
  }

  // async getAssignTripRecord(stId) {
  //   var postData = { stId: stId };
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=trip&a=getTripdata", "postData=" + base64Input);
  //   console.log(response);
  //   return response.data?.data[0];
  //   // this.tripDataArray= response.data.data
  // }

  async getAddressUsingLatLng(lat, lng) {
    let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${config.googleMapKey}`;
    const response = await axios(url);
    let address = await response.data.results[0].formatted_address;

    this.addr = address;
    return address;
  }
}

export default AssignTripStore;
